import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  subscription: null,
};

const slice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getSubscriptionSuccess(state, action) {
      state.isLoading = false;
      state.subscription = action.payload;
    },

    resetError(state) {
      state.error = null;
    },
  },
});

export default slice.reducer;

export const { resetError } = slice.actions;

// ----------------------------------------------------------------------

export function fetchSubscriptionStatus() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOST_API}/subscriptions/me`
      );
      dispatch(slice.actions.getSubscriptionSuccess(response.data.data));
    } catch (error) {
      const message = error?.error?.message || 'Subscriptions/GetMe/InternalError';
      dispatch(slice.actions.hasError(message));
    }
  };
}

// ----------------------------------------------------------------------

export function createPortalSession() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_HOST_API}/subscriptions/portal`
      );
      dispatch(slice.actions.getSubscriptionSuccess(null));
      return response.data.data.url;
    } catch (error) {
      const message = error?.error?.message || 'Subscriptions/Portal/InternalError';
      dispatch(slice.actions.hasError(message));
      return null;
    }
  };
}

// ----------------------------------------------------------------------

export function fetchInvoices() {
  return async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOST_API}/subscriptions/invoices`
      );
      return response.data?.data || [];
    } catch (error) {
      return [];
    }
  };
}

// ----------------------------------------------------------------------

export function cancelSubscription() {
  return async (dispatch) => {
    try {
      await axios.delete(`${process.env.REACT_APP_HOST_API}/subscriptions/cancel`);
      await dispatch(fetchSubscriptionStatus());
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  };
}
